/** Public commercial copy; paid sales stay server-gated pending legal/tax approval. */
export const EVENT_PASS_SIZES = [
  { key: "xs", label: "XS", entries: 50, usd: 49 },
  { key: "s", label: "S", entries: 100, usd: 69 },
  { key: "m", label: "M", entries: 150, usd: 89 },
  { key: "l", label: "L", entries: 250, usd: 129 },
] as const;
export const SUBSCRIPTION_PRICES = {
  club: { monthly: 99, annual: 790 },
  tour: { monthly: 199, annual: 1990 },
} as const;
export const PUBLIC_OFFERS = [
  {
    name: "Free",
    price: "USD 0",
    period: "No subscription",
    features: [
      "2 competitions per calendar year",
      "Up to 50 entries each",
      "Live scoring · up to 16 judges",
      "Watermarked OBS overlay",
      "Public results and TV mode",
    ],
    cta: "Start free",
    accent: false,
  },
  {
    name: "Event pass",
    price: `USD ${EVENT_PASS_SIZES[0].usd}`,
    period: "from · one competition",
    features: [
      ...EVENT_PASS_SIZES.map(
        (size) => `${size.label} · up to ${size.entries} entries · USD ${size.usd}`,
      ),
      "More than 250: contact us or choose Club Unlimited",
      "Shipped Club features for one competition",
      "Email support, next business day",
    ],
    cta: "Create a free account",
    accent: false,
  },
  {
    name: "Club Unlimited",
    price: `USD ${SUBSCRIPTION_PRICES.club.monthly}`,
    period: `/month · USD ${SUBSCRIPTION_PRICES.club.annual}/year`,
    features: [
      "Unlimited competitions",
      "No entry cap",
      "OBS overlay without watermark",
      "Sponsor placements and core PDFs",
      "Email support, next business day",
    ],
    cta: "Create a free account",
    accent: true,
  },
] as const;
